<template>
    <div class="container-fluid">
        <b-overlay :show="showOverlay" rounded="sm">
            <grid
                controllers='true' 
                :titles='titles'
                :data='data'
                current-sort="id"
                :search-key="search"
                @clicked="onClickEvent"
            />
        </b-overlay>
    </div>
</template>
<script>
    import grid from '@/components/grid.vue'
    export default {
        name: 'VWGrupo',
        data(){
            return {
                showOverlay: false,
                titles: ['ID', 'DESCRICAO', 'ATIVO', 'TIPO', 'VISUALIZAR WEB', 'VISUALIZAR PC', 'VISUALIZAR ANDROID'],
                data: [],
                search: 'descricao',
                searching: 0
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        components: {
            grid
        },
        methods: {
            getData: function(){
                this.showOverlay = true
                // eslint-disable-next-line
                fetch(server + 'crud/grupo', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data == true){
                            this.data = responseJSON.response
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
                    .finally(() => {
                        this.showOverlay = false
                    })
            },

            onClickEvent: function(value){
                this.$router.push({
                    name: 'grupos.editar',
                    params: {
                        id: value.id
                    }
                })
            }
        },

        mounted(){
            this.getData()
        }
    }
</script>